import Vue from 'vue'
import Vuex from 'vuex'
import {ObjectsWithId, Lead, Payout} from 'src/classes/datamodel.js'
import api from './apiServices.js'
import router from '../router/router.js'
import { progress } from '../utils'
import { Affiliate, AffiliateCompanyProxy, UserProfile, User } from '../classes/datamodel.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
      userSession: '',
      periodSelected: {}, // {value: 'this month', label: 'This Month' previous: 'Last Month', evo: 'Last 12 Months'}
      companySelected: 0,
      modal: { mode: '', current: '', object: {} },
      selectedObjects: { objectsJson: null, filter: null }, // Select mode is initiated in tables when objectsJson != null
      classes: {
        Payout: {
          _status: Payout._status,
          _type: Payout._type
        },
        Lead: {
          _status: Lead._status
        }
      },
      data: {
        // affiliatesJson: new ObjectsWithId(),
        leadsJson:      new ObjectsWithId(),
        payoutsJson:    new ObjectsWithId(),
        // companiesJson:  new ObjectsWithId()
        invoicesJson: new ObjectsWithId()
      },
      dataPrevious: {
        // affiliatesJson: new ObjectsWithId(),
        leadsJson:      new ObjectsWithId(),
        payoutsJson:    new ObjectsWithId(),
        // companiesJson:  new ObjectsWithId()
      },
      dataEvolution: { // for the graphs displaying evolution over the year
        affiliates: { lineChart: {}, pieChart: {}, barChart: {} },
        leads:      { lineChart: {}, pieChart: {}, barChart: {} },
        payouts:    { lineChart: {}, pieChart: {}, barChart: {} }
      },
      baseData: {
        usersJson: new ObjectsWithId(),
        userProfilesJson: new ObjectsWithId(),
        affiliateCompaniesJson:  new ObjectsWithId(),
        affiliatesJson: new ObjectsWithId(),
        periods: [],
        accountProfile: {
          companyName: '',
          contactEmail: '',
          address: '',
          city: '',
          country: '',
          state: '',
          postalCode: '',
          about: '',
          timezoneOffset: undefined,
          dateModified: null
        },
        spiffsLeadsSetup: {
          manageLeadsMode: null,
          spiffReceivedLeads: null,
          spiffForReceivedLead: null,
          spiffClosedLeads: null,
          spiffForClosedLead: null,
          dateModified: null,
          welcomeSpiff: 19
        },
        accountSetup: {
          timezoneOffset: undefined,
          fiscalStartMonth: ''
        }
      }
    },





    /////////////////////////////////////////////////////
    ///////////////////// GETTERS ///////////////////////
    /////////////////////////////////////////////////////
    getters: {
      currency                () { return '$' }, 
      periodSelected     (state) { return state.periodSelected },
      companySelected    (state) { return state.companySelected },
      accountSetup       (state) { return state.baseData.accountSetup },
      accountProfile     (state) { return state.baseData.accountProfile },
      spiffsLeadsSetup   (state) { return state.baseData.spiffsLeadsSetup },
      periods            (state) { return state.baseData.periods },
      modal              (state) { return state.modal },

      Payout             (state) { return state.classes.Payout },
      Lead               (state) { return state.classes.Lead },

      session            (state) { return state.userSession || JSON.parse(localStorage.getItem('userSession')) },
      user               (state, getters) { return getters.session.user },

      usersJson          (state) { return state.baseData.usersJson },
      users              (state, getters) { return getters.usersJson ? getters.usersJson.values : [] },
      userProfilesJson   (state) { return state.baseData.userProfilesJson },
      userProfiles       (state, getters) { return getters.userProfilesJson ? getters.userProfilesJson.values || [] : [] },
      
      affiliatesJson     (state, getters) { return state.baseData.affiliatesJson.forCompanyId(getters.companySelected) },
      affiliates         (state, getters) { return getters.affiliatesJson.values },
      // affiliatesPreviousJson (state, getters) { return state.dataPrevious.affiliatesJson.forCompanyId(getters.companySelected) },
      // affiliatesPrevious     (state, getters) { return getters.affiliatesPreviousJson.values },
      /* affiliatesEvolutionJson (state, getters) { return state.dataEvolution.affiliatesJson.forCompanyId(getters.companySelected)}, */
      affiliatesEvolution (state, getters) { return state.dataEvolution.affiliates[getters.companySelected] },

      leadsJson (state, getters) { return state.data.leadsJson.forCompanyId(getters.companySelected,
                                                                           {affiliates: getters.affiliatesJson}) },
      leads (state, getters) { return getters.leadsJson.values },
      leadsPreviousJson (state, getters) { return state.dataPrevious.leadsJson.forCompanyId(getters.companySelected,
                                                                                           {affiliates: getters.affiliatesJson}) },
      leadsPrevious (state, getters) { return getters.leadsPreviousJson.values },
      /* leadsEvolutionJson (state, getters) { return state.dataEvolution.leadsJson.forCompanyId(getters.companySelected) }, */
      leadsEvolution (state, getters) { return state.dataEvolution.leads[getters.companySelected] },

      invoicesJson (state) { return state.data.invoicesJson || {} },
      invoices (state, getters) { return getters.invoicesJson.values || [] },
      companiesJson (state) { return state.baseData.affiliateCompaniesJson },
      companies (state, getters) { return getters.companiesJson ? getters.companiesJson.values || [] : [] },

      payoutsJson (state, getters) { return state.data.payoutsJson.forCompanyId(getters.companySelected,
                                                                  {affiliates: getters.affiliatesJson})},
      payouts (state, getters) { return getters.payoutsJson.values },
      payoutsPreviousJson (state, getters) {
        return state.dataPrevious.payoutsJson.forCompanyId(getters.companySelected,
                                                          {affiliates: getters.affiliatesJson})},
      payoutsPrevious (state, getters) { return getters.payoutsPreviousJson.values },
      /* payoutsEvoluionJson (state, getters) {
        return state.dataEvolution.payoutsJson.forCompanyId(getters.companySelected,
                                                            {affiliates: getters.affiliatesJson})}, */
      payoutsEvolution (state, getters) { return state.dataEvolution.payouts[getters.companySelected] },
      
      selectedObjectsJson (state) {
        return state.selectedObjects.objectsJson
      },

      selectedObjects (state, getters) {
        return getters.selectedObjectsJson ? getters.selectedObjectsJson.values : []
      },
      
      selectedObjectsFilter (state) {
        return state.selectedObjects.filter
      },
      



      





    /////////////////////////////////////////////////////
    //////////////////// FUNCTIONS //////////////////////
    /////////////////////////////////////////////////////
      affiliatesLeads (state, getters) { // returns all affiliates with their leads leads and totals
        var res = {}
        getters.affiliates.forEach(aff => {
          // console.log('1: aff.id = ', aff.id)
          var leads = { total: 0, closed: 0, lost: 0, closeRate: 0, leads: [] }
          getters.leads.forEach(lead => {
            // console.log('2: lead.affiliateId = ', lead.affiliateId)
            if (lead.affiliateId == aff.id) {
              leads.total += 1
              switch (lead.status) {
                case Lead._status.CLOSED.value:
                  leads.closed += 1
                  break
                case Lead._status.LOST.value:
                  leads.lost += 1
                  break
                default:
                  break
              }
            }
            // console.log('3: leads = ', leads)
          })
          leads.closeRate = leads.closed ? Math.round(100 * leads.closed / leads.total) : 0
          res[aff.id] = leads
        })
        return res
      },
      totalLeads (state, getters) {
        //console.log('totalLeads: ', getters.leads.length)
        return getters.leads.length || 0
      },
      totalLeadsPrevious (state, getters) {
        return getters.leadsPrevious.filter(l => l.archived != true).length || 0
      },
      totalLeadsClosed (state, getters) {
        var total = 0
        getters.leads.forEach(elem => {
          if (elem.archived != true) {
            total += elem.status == Lead._status.CLOSED.value ? 1 : 0
          }
        })
        return total
      },
      totalLeadsClosedPrevious (state, getters) {
        var total = 0
        getters.leadsPrevious.forEach(elem => {
          if (elem.archived != true) {
            total += elem.status == Lead._status.CLOSED.value ? 1 : 0
          }
        })
        return total
      },
      // Returns true is minimum necessary setup data is present
      isSetupComplete (state, getters) {
        let bd = state.baseData
        let p = getters.accountProfile
        let as = getters.accountSetup
        let s = getters.spiffsLeadsSetup
        let res = !!bd && p && as
                  && getters.isAccountProfileComplete
                  && getters.isAccountSetupComplete
                  && getters.isSpiffsLeadsSetupComplete
                  && bd.periods
                    && bd.periods.length > 0
                  // && getters.isAffiliateCompaniesSetupComplete
        return res
      },
      
      // Returns true is account setup is complete
      isAccountSetupComplete (state, getters) {
        const as = getters.accountSetup
        return !!as && (as.timezoneOffset || as.timezoneOffset == 0)
                    // && as.fiscalStartMonth
      },
      
      // Returns true if the account details are complete
      isAccountProfileComplete (state, getters) {
        const p = getters.accountProfile
        return !!p && p.companyName
                   && p.contactEmail
                   && p.address
                   && p.address.addressLine1
                   && p.address.city
                   && p.address.country
                   && p.address.state
                   && p.address.postalCode
      },
      
      // Return true if the SpiffLeadsSetup is properly completed
      isSpiffsLeadsSetupComplete (state, getters) {
        const s = getters.spiffsLeadsSetup
        return !!s
          && s.manageLeadsMode != null
          && !(s.spiffReceivedLeads && !s.spiffForReceivedLead)
          && !(s.spiffClosedLeads && !s.spiffForClosedLead)
      },
      
      // Returns true if the minimum conditions have been met (1 company + 1 affiliate)
      isAffiliateCompaniesSetupComplete (state, getters) {
        return !!getters.companiesJson
          && getters.companies.length > 0
          && getters.companies.filter(c => !c.archived).length > 0
          && getters.affiliatesJson
          && state.baseData.affiliatesJson.length > 0
          && state.baseData.affiliatesJson.filter(a => !a.archived).length > 0
      },

      // Return the evolution period corresponding to the currentyl selected period
      periodEvolution (state, getters) {
        let period = getters.periods.find(p => p.value == getters.periodSelected.evolution)
        if (period) {
          return period
        }
        else {
          return {}
        }
      },


      




    /////////////////////////////////////////////////////
    ////////////// FUNCTIONS WITH ARGUMENTS /////////////
    /////////////////////////////////////////////////////
      // Functions with arguments:
      totalPayouts: (state, getters) => obj => {
        let total = 0
        let payouts = getters.payouts.filter(p =>  !p.archived)
        if (obj && obj.status) {
          payouts = payouts.filter(p => p.status == obj.status.value)
        }
        payouts.forEach(elem => {
          total += elem.amount || 0
        })
        return total
      },
      totalPayoutsPrevious: (state, getters) => obj => {
        let total = 0
        let payouts = getters.payoutsPrevious
        if (obj && obj.status) {
          payouts = payouts.filter(p => p.status == obj.status.value)
        }
        payouts = payouts.filter(p => p.archived != true)
        payouts.forEach(elem => {
          total += elem.amount || 0
        })
        return total
      },
      getCompanyName: (state, getters) => companyId => {
        var res = getters.companies.find(elem => elem.id == companyId)
        return res && res.profile ? res.profile.companyName : '-'
      },
      getAffiliateName: (state, getters) => affiliateId => {
        var res = getters.affiliates.find(elem => elem.id == affiliateId)
        return res ? res.firstName + ' ' + res.lastName : '-'
      },
      getPayoutsForAffiliate: (state, getters) => arg => {
        var affiliateId = null
        if (typeof arg == 'object') {
          affiliateId = arg.id
        } else {
          affiliateId = Number(arg)
        }
        if (affiliateId == null || affiliateId == 0) {
          // TODO: we'll return payouts for all affiliates
        }

        var payouts = {
          total: 0,
          pending: 0,
          paid: 0,
          payouts: []
        }
        getters.payouts.filter(p => !p.archived).forEach(elem => {
          //console.log('getPayoutsForAffiliate:', elem.amount)
          if (!affiliateId || elem.affiliateId == affiliateId) {
            if (Number(elem.amount) && elem.amount > 0) {
              payouts.total += elem.amount
              payouts.payouts.push(elem)
              switch (elem.status) {
                case Payout._status.PAID.value:
                  payouts.paid += elem.amount
                  break
                default:
                  payouts.pending += elem.amount
                  break
              }
            }
          }
        })
        return payouts
      },
      /** This function is needed because if only the total property is used for the result of getPayoutsForAffiliate(), the reactivity doesn't work */
      // getPayoutsTotalForAffiliate: (state, getters) => arg => {
      //   return getters.getPayoutsForAffiliate(arg).total

      // },
      getPayoutsForCompany: (state, getters) => arg => {
        var companyId = null
        if (typeof arg == 'object') {
          companyId = arg.id
        } else {
          companyId = Number(arg)
        }
        if (companyId == null || companyId == 0) {
          // we'll return payouts for all companies
        }

        var payouts = {
          total: 0,
          pending: 0,
          paid: 0,
          payouts: []
        }
        getters.payoutsJson.forCompanyId(companyId).values.forEach(elem => {
          //console.log('getPayoutsForAffiliate:', elem.amount)
          if (!companyId || elem.affiliateId == affiliateId) {
            if (Number(elem.amount) && elem.amount > 0) {
              payouts.total += elem.amount
              payouts.payouts.push(elem)
              switch (elem.status) {
                case Payout._status.PAID.value:
                  payouts.paid += elem.amount
                  break
                default:
                  payouts.pending += elem.amount
                  break
              }
            }
          }
        })
        return payouts
      },

      //////////////////// User Permissions: ///////////////////
      // returns trus is user has this permission
      isPermitted: (state, getters) => permission => {
        let permissions = getters.user.permissions
        //TODO
        return true
      }
    },
    






    /////////////////////////////////////////////////////
    ///////////////////// MUTATIONS /////////////////////
    /////////////////////////////////////////////////////
    mutations: {

      MODAL_OBJECT (state, object) {
        console.log('commit modal object')
        if (object) {
          state.modal.object = object
        }
        const tmp = state.modal
        state.modal = null
        state.modal = tmp
      },

      UPDATE_LEADS (state, leads) {
        state.data.leadsJson = leads
      },
      UPDATE_LEADS_PREVIOUS (state, leads) {
        state.dataPrevious.leadsJson = leads
      },
      UPDATE_LEADS_EVOLUTION (state, leads) {
        state.dataEvolution.leads = leads
      },
      UPDATE_PAYOUTS (state, payouts) {
        state.data.payoutsJson = payouts
      },
      UPDATE_INVOICES (state, invoices) {
        state.data.invoicesJson = invoices
      },
      // UPDATE_PAYOUT (state, payout) {
      //   state.data.payoutsJson[payout.id] = payout
      // },
      UPDATE_PAYOUTS_PREVIOUS (state, payouts) {
        state.dataPrevious.payoutsJson = payouts
      },
      UPDATE_PAYOUTS_EVOLUTION (state, payouts) {
        state.dataEvolution.payouts = payouts
      },
      UPDATE_AFFILIATES (state, affiliates) {
        state.baseData.affiliatesJson = affiliates
      },
      // UPDATE_AFFILIATES_PREVIOUS (state, affiliates) {
      //   state.dataPrevious.affiliatesJson = affiliates
      // },
      // UPDATE_AFFILIATES_EVOLUTION (state, affiliates) {
      //   state.dataEvolution.affiliates = affiliates
      // },
      UPDATE_AFFILIATE_COMPANIES (state, companies) {
        state.baseData.affiliatesCompaniesJson = companies
      },
      // UPDATE_AFFILIATE_COMPANIES_PREVIOUS (state, companies) {
      //   state.dataPrevious.companiesJson = companies
      // },
      // UPDATE_AFFILIATE_COMPANIES_EVOLUTION (state, companies) {
      //   state.dataEvolution.companies = companies
      // },


      UPDATE_BASE_DATA (state, payload) {
        console.log('UPDATE_BASE_DATA, payload = ', payload)
        state.baseData = payload
      },
      STORE_SESSION (state, userSession) {
        localStorage.setItem('userSession', JSON.stringify(userSession))
        state.userSession = userSession
      },
      /** This methods removes the token and user from local storage and removes the session in the state */
      CLEAR_SESSION (state) {
        let userSession = state.userSession
        console.log('CLEAR_SESSION, userSession = ', userSession)
        if (userSession && userSession.token) {
          userSession.token = ''
          userSession.user = ''
          localStorage.setItem('userSession', JSON.stringify(userSession))
          state.userSession = ''
        }
      },
      
      UPDATE_ACCOUNT_PROFILE (state, accountProfile) {
        state.baseData.accountProfile = accountProfile
      },
      
      UPDATE_ACCOUNT_SETUP (state, accountSetup) {
        state.baseData.accountSetup = accountSetup
      },
      
      UPDATE_SPIFFS_LEADS_SETUP (state, spiffsLeadsSetup) {
        state.baseData.spiffsLeadsSetup = spiffsLeadsSetup
      },



      //////////////////////////// Other: ////////////////////////////
      SET_PERIOD_SELECTED (state, period) {
        if (typeof period == 'string') {
          state.periodSelected = state.baseData.periods.find(p => p.value == period)
        }
        else {
          state.periodSelected = period
        }
      },
      SET_COMPANY_SELECTED (state, company) { // can take either AffiliateCompany or companyId as parameter
        if (!company && company != 0) {
          const affiliateCompanies = state.baseData.affiliateCompaniesJson.values
          if (affiliateCompanies && affiliateCompanies.length > 0) {
            company = affiliateCompanies.length > 1 ? 0 : affiliateCompanies[0].id
          }
          else company = 0
        }
        state.companySelected = Number(company) || company == 0 ? company : company.id
      },
      OPEN_MODAL (state, arg) {
        console.log('OPEN_MODAL: ', arg)
        // Lead modal:
        if (arg.name == 'Lead') {
          switch (arg.mode) {
            case 'Create':
              state.modal.object = arg.object || new Lead({status: Lead._status.RECEIVED.value})
              break;
            case 'Close':
              state.modal.object = arg.object || new Lead({status: Lead._status.CLOSED.value})
              console.log('close')
              break;
            case 'Lost':
              console.log('lost')
              state.modal.object = arg.object || new Lead({status: Lead._status.LOST.value})
              break;  
            case 'Edit':
              console.log('Edit')
            default:
              state.modal.object = arg.object || new Lead()
              break;
          }
          if (arg.mode == 'Close' || arg.mode == 'Lost') {
            // we activate the table row select mode (checkboxes)
            state.selectedObjects.objectsJson = new ObjectsWithId()
          }
        } else {
          // Other modals
          state.modal.object = arg.object
        }
        
        state.modal.mode = arg.mode || ''
        state.modal.current = arg.name
      },
      CLOSE_MODAL (state) {
        state.modal.current = ''
        state.modal.object = {}
        state.modal.mode = ''

      },
      SAVE_SPIFFS_LEADS_SETUP (state, options) {
        state.baseData.spiffsLeadsSetup = options
        const tmp = state.baseData
        state.baseData = null // to refresh reactivity
        state.baseData = tmp
      },

      // This activates the 'select objects' mode
      SELECT_OBJECTS (state, filter) {
        state.selectedObjects.objectsJson = new ObjectsWithId()
        state.selectedObjects.filter = filter || null
      },
      // This deactivates the 'select objects' mode
      STOP_SELECT_OBJECTS (state) {
        state.selectedObjects.objectsJson = null
        state.selectedObjects.filter = null
      },
      // This updates the list of selected objects
      SELECT_OBJECT (state, obj) {
        if (obj && obj.id && state.selectedObjects.objectsJson) {
          if (state.selectedObjects.objectsJson[obj.id]) { // if object already selected, we remove it
            delete state.selectedObjects.objectsJson[obj.id]
          }
          else { // otherwise we add it
            state.selectedObjects.objectsJson[obj.id] = obj
          }
          state.selectedObjects.objectsJson = new ObjectsWithId(state.selectedObjects.objectsJson.values) // to force refresh bindings
        }
      }
    },








    



    
    /////////////////////////////////////////////////////
    ///////////////////// ACTIONS ///////////////////////
    /////////////////////////////////////////////////////
    actions: {
      openModal     ({state, commit}, arg)  {
        commit('OPEN_MODAL', arg)
        return { res: true }
      },
      closeModal    ({state, commit}) {
        commit('CLOSE_MODAL')
        return { res: true }
      },
      
      
      
      async inviteAffiliate ({commit, dispatch}, invitation) {
        const res = await api.inviteAffiliate(invitation)
        return res
      },
      
      async revokeAffiliate ({state}, { affiliateAccountId, affiliateIncentifyerRelationshipId }) {
        // alert(`store: ` + affiliateIncentifyerRelationshipId)
        progress.start()
        const res = await api.revokeAffiliate(affiliateAccountId, affiliateIncentifyerRelationshipId)
        progress.done()
        return res
      },



      async requestPayoutsSubmission ({state, dispatch}, payouts) {
        //console.log('requestPayoutsSubmission(): payouts = ', payouts)
        progress.start()
        //progress.inc(0.4)
        let res = false
        let i = 0
        for (let payout of payouts) {
          //console.log(i++)
          payout.status = Payout._status.SUBMISSION_REQUESTED.value
          res = (await api.updateRestObject(new Payout(payout))).result && res
        }
        dispatch('fetchData')
        return { result: res }
      },
      async submitPayoutsForPayment ({state, dispatch}, payouts) {
        progress.start()
        //progress.inc(0.4)
        let res = false
        for (let payout of payouts) {
          payout.status = Payout._status.SUBMITTED.value
          res = (await api.updateRestObject(new Payout(payout))).result && res
        }
        dispatch('fetchData')
        return { result: res }
      },





      async closeLeads ({state, dispatch}) {
        if (state.selectedObjects && state.selectedObjects.objectsJson && state.selectedObjects.objectsJson.length > 0) {
          for (let i = 0; i < state.selectedObjects.objectsJson.length; i++) {
            let lead = new Lead(state.selectedObjects.objectsJson.values[i])
            lead.status = Lead._status.CLOSED.value
            const res = await api.updateRestObject(lead)
            if (res.errors) {
              return res
            }
          }
          dispatch('fetchData')
          return {result: true}
        }
      },

      async lostLeads ({state, dispatch}) {
        if (state.selectedObjects && state.selectedObjects.objectsJson && state.selectedObjects.objectsJson.length > 0) {
          for (let i = 0; i < state.selectedObjects.objectsJson.length; i++) {
            let lead = state.selectedObjects.objectsJson.values[i]
            lead.status = Lead._status.LOST.value
            const res = await api.updateRestObject(new Lead(lead))
            if (res.errors) {
              return res
            }
          }
          dispatch('fetchData')
          return {result: true}
        }
      },
      
      deleteLead ({commit}, lead) {
        // db.delete(lead)
        //commit('DELETE_LEAD', lead)
        alert('Not implemented')
      },
      
      async createPayoutsInvoice ({commit}) {
        progress.start()
        progress.set(0.4)
        const res = await api.createPayoutsInvoice()
        progress.done()
        return res
      },
      
      async resendInvitation ({commit}, payload) {
        progress.start()
        progress.set(0.4)
        const res = await api.resendInvitation(payload)
        progress.done()
        return res
      },

      
      //////////////////////////// Users: ////////////////////////////
      // createUser({commit}, user) {
      //   // db.createUser(user)
      // },
      // updateUser({commit}, user) {
      //   // db.updateUser(user)
      // },
      // deleteUser({commit}, user) {
      //   // db.deleteUser(user)
      // },

      /////////////////////////// Rest actions: ///////////////////////
      async createRestObject ({commit, dispatch}, object) {
        // console.log('object = ', object)
        // console.log('object.constructor.name = ', object.constructor.name)
        progress.start()
        progress.set(0.4)
        let res = await api.createRestObject(object)
        if (res && !res.errors) {
          progress.start()
          progress.set(0.4)
          if (object instanceof Affiliate || object instanceof AffiliateCompanyProxy
              || object instanceof User || object instanceof UserProfile) {
            dispatch('fetchBaseData').then(() => progress.done())
          }
          else {
            dispatch('fetchData').then(() => progress.done())
          }
        }
        else {
          progress.done()
        }
        return res
      },
      async updateRestObject ({commit, dispatch}, object) {
        console.log('object = ', object)
        console.log('object.constructor.name = ', object.constructor.name)
        progress.start()
        progress.set(0.4)
        let res = await api.updateRestObject(object)
        console.log('store.js: updateRestObject(), res = ', res)
        if (res && !res.errors) {
          progress.start()
          progress.set(0.4)
          if (object instanceof Affiliate || object instanceof AffiliateCompanyProxy
              || object instanceof User || object instanceof UserProfile) {
            console.log('fetching BaseData from updateRestOjbect()')
            dispatch('fetchBaseData').then(() => progress.done())
          }
          else {
            dispatch('fetchData').then(() => progress.done())
          }
        }
        else {
          progress.done()
        }
        return res
      },
      async getRestObject ({commit}, object) {
        progress.start()
        progress.set(0.4)
        let res = await api.getRestObject(object)
        progress.done()
        return res
      },
      async getRestObjects ({commit}, object) {
        progress.start()
        progress.set(0.4)
        let res = await api.getRestObjects(object)
        progress.done()
        return res
      },
      
      
      
      //////////////////////////// Session: //////////////////////////
      async login ({commit}, creds) {
        var response = await api.login(creds)
        console.log('Store > login(): response = ', response)
        if (response.errors) {
          console.log('Store > login(): error')
          return response
        }
        else {
          if (response.userSession && response.userSession.user
           && response.userSession.user.status == 'pending') {
            router.push('/changePassword')
          }
          else {
            router.push('/admin')//.catch(e => console.log('catch in login():', e))
          }
          return response
        }
      },
      
      /** Change the user password */
      async changePassword ({commit}, password) {
        const response = await api.changePassword(password)
        if (!response.errors) {
          router.push('/admin')
          return
        }
        else  {
          return response
        }
      },

      /** Clears the session in the local storage, close any open modal, and reroutes to login page */
      async logout ({commit}) {
        console.log('Store > logout()')
        commit('CLEAR_SESSION')
        commit('CLOSE_MODAL')
        router.push('/login')
      },
      async isSessionValid ({commit}) {
         return await api.isSessionValid()
      },
      setToken ({commit}, token) {
        api.setDefaultToken(token)
        return true
      },

      //////////////////////////// Base Data: ////////////////////////////
      async saveSpiffsLeadsSetup ({commit}, obj) {
        const res = await api.saveSpiffsLeadsSetup(obj)
        if (res) {
          commit('UPDATE_SPIFFS_LEADS_SETUP', obj)
        }
        return res
      },
      async saveAccountSetup ({commit}, obj) {
        const res = await api.saveAccountSetup(obj)
        if (res) {
          commit('UPDATE_ACCOUNT_SETUP', obj)
        }
        return res
      },
      async saveAccountProfile ({commit}, obj) {
        const res = await api.saveAccountProfile(obj)
        if (res) {
          commit('UPDATE_ACCOUNT_PROFILE', obj)
        }
        return res
      },
      async fetchBaseData ({state, commit}) {
        const res = (await api.getBaseData())
        if (res && res.baseData) {
          var baseData = res.baseData
          console.log('fetchBaseData(): ', baseData)
          //baseData.users = dbdata.users
          baseData.loaded = true // if this useful??

          // we changes the Arrays<ObjectWithId> into ObjectsWithId objects
          baseData.usersJson = new ObjectsWithId(baseData.users)
          delete baseData.users
          baseData.userProfilesJson = new ObjectsWithId(baseData.userProfiles)
          delete baseData.userProfiles
          baseData.affiliateCompaniesJson = new ObjectsWithId(baseData.affiliateCompanyProxies)
          delete baseData.affiliateCompanyProxies
          baseData.affiliatesJson = new ObjectsWithId(baseData.affiliateProxies)
          delete baseData.affiliateProxies
          commit('UPDATE_BASE_DATA', baseData)
        }
        else {
          // We don't show the session invalid message because the apiService already reroutes to login page
          if (!(typeof result.errors[0] == 'string' && result.errors[0].toLowerCase().includes('session'))) {
            Vue.prototype.$notify({errorMessage: result.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue.message)})
          }
          progress.done()
        }
      },


    
    /////////////////////// FETCH DATA ////////////////////////
    

      async fetchData ({state, commit}, { period = (state.periodSelected ? state.periodSelected.value || 'this month+' : 'this month+'),
                                          scope = router.currentRoute.path.split('/')[2] }={}) {
        // console.log(`fetchData(): ${period}, ${scope}`)
        // get the data from the API
        if (!period) {
          console.log('No period provided to store.js: fetchData()')
          return undefined
        }
        // console.log(`Before fetch`)
        progress.start()
        // progress.inc(0.4)
        const result = await api.fetchData(period, scope)
        // console.log('fetchData get result = ', result)

        if (!result) {
          progress.done()
          return result
        }
        if (result.errors) {
          // We don't show the session invalid message because the apiService already reroutes to login page
          if (!(typeof result.errors[0] == 'string' && result.errors[0].toLowerCase().includes('session'))) {
            Vue.prototype.$notify({errorMessage: result.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue.message)})
          }
          progress.done()
          return { result: false }
        }
        else {
          console.log(`After fetch result = `, result)
          // Data for this period
          if (result.data) {
            if (result.data.data) {
              const data = result.data.data
              if (data.leads && data.leads.length > -1) {
                commit('UPDATE_LEADS', new ObjectsWithId(data.leads))
              }
              if (data.payouts && data.payouts.length > -1) {
                commit('UPDATE_PAYOUTS', new ObjectsWithId(data.payouts))
              }
              if (data.invoices && data.invoices.length > -1) {
                commit('UPDATE_INVOICES', new ObjectsWithId(data.invoices))
              }
            }
            // Data for the previous period
            if (result.data.dataPrevious) {
              const dataPrevious = result.data.dataPrevious
              if (dataPrevious.leads && dataPrevious.leads.length > -1) {
                commit('UPDATE_LEADS_PREVIOUS', new ObjectsWithId(dataPrevious.leads))
              }
              if (dataPrevious.payouts && dataPrevious.payouts.length > -1) {
                commit('UPDATE_PAYOUTS_PREVIOUS', new ObjectsWithId(dataPrevious.payouts))
              }
            }
            // Data for the evolution graphs
            if (result.dataEvolution) {
              const dataEvolution = result.data.dataEvolution
              if (dataEvolution.leads && dataEvolution.leads.length > -1) {
                commmit('UPDATE_LEADS_EVOLUTION', new ObjectsWithId(dataEvolution.leads))
              }
              if (dataEvolution.payouts && dataEvolution.payouts.length > -1) {
                commmit('UPDATE_PAYOUTS_EVOLUTION', new ObjectsWithId(dataEvolution.payouts))
              }
              if (dataEvolution.affiliates && dataEvolution.affiliates.length > -1) {
                commmit('UPDATE_AFFILIATES_EVOLUTION', new ObjectsWithId(dataEvolution.affiliates))
              }
              // if (dataEvolution.affiliateCompanies && dataEvolution.affiliateCompanies.length > -1) {
              //   commmit('UPDATE_AFFILIATE_COMPANIES_EVOLUTION', new ObjectsWithId(dataEvolution.affiliateCompanies))
              // }
            }
          }
          progress.done()
          return { result: true }
        }
      }
    }
})